import version from '../../package.json';

const appVersion = `${version}-dev`;

const AZURE_SSO_CLIENT_ID = '4f884bc2-b31a-469f-982e-dee95e9364a7';

export const environment = {
  production: false,
  LOG_LEVEL: 'WARN',
  AZURE_SSO_CLIENT_ID: AZURE_SSO_CLIENT_ID,
  AZURE_SSO_TENANT_ID: 'd0dd8c54-2968-4466-a8e7-9684352ae906',
  AG_GRID_LICENSE_KEY:
    'Using_this_{AG_Grid}_Enterprise_key_{AG-060029}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Outamation_Inc}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{14_May_2025}____[v3]_[01]_MTc0NzE3NzIwMDAwMA==647cb38634ea135fabc48ef0d3eb019f',
  BASE_URL: 'https://outamate.outamationlabs.com/gateway/',
  BASE_URL_HOST: 'https://outamate.outamationlabs.com',
  REDIRECT_URL: '/via-ui/',
  IsSSO: false,
  AZURE_SSO_SCOPE_URI: `api://${AZURE_SSO_CLIENT_ID}/info.read`,
  appVersion,
  WORKFLOW_URL: 'https://outamate.outamationlabs.com/works-ui',
};
